module.exports = __webpack_public_path__ + "static/media/mq1White@2x.3239e8a0.png";